module.exports = __webpack_public_path__ + "img/new-pcs.acc3afb6.png";